// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"_93444fe79c--wrapper--vqW63","button":"_93444fe79c--button--vynM5"};